import React, { ReactElement, useReducer } from 'react';
import { ConversationContext, conversationReducer, initialState } from 'hooks/conversation';

const ConversationProvider: React.FC<PropsWithChildren> = ({ children }): ReactElement => {
  const [conversationState, dispatchConversationAction] = useReducer(
    conversationReducer,
    initialState,
  );
  return (
    <ConversationContext.Provider value={{ conversationState, dispatchConversationAction }}>
      {children}
    </ConversationContext.Provider>
  );
};

export default ConversationProvider;
